import { watch } from 'vue';

export default {
  name: 'FinancialSummary',
  components: {},
  props: {
    prize: Object,
    isProposition: Boolean,
    isLoading: Boolean,
  },
};
